function aggiungi () {
  this.$eventBus.emit('show-dialog-page', {
    page: 'fatture-acquisto-aggiungi',
    title: 'Aggiungi Fattura Acquisto',
    data: {},
    maximize: false,
  })
}

export default {
  'bindTo': 'this',
  'method': aggiungi,
}
